import React from 'react';

import firebase from './../../firebase';

class PetitionList extends React.Component {

    state = {
        list: [],
        loading: true,
    }

    componentDidMount() {
        this.unsubscribe = firebase.collection('petition').orderBy('createdAt', 'desc').onSnapshot((docs) => {
            let list = [];
            docs.forEach((doc) => {
                let data = doc.data();
                list.push(data);
            });
            this.setState({list, loading: false})
        });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }
    
    render() {
        return(
            <div className="petition-list">
                {this.state.loading && <div>Laddar...</div>}
                {!this.state.loading && this.state.list.map((item, i) => {
                    return (
                        <div style={{marginBottom: 5}} key={i}>
                            {item.first_name} {item.last_name}{item.organization ? ', ' + item.organization : ''}, {item.city}
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default PetitionList;


// WEBPACK FOOTER //
// ./src/components/petition/PetitionList.js